export enum FormFieldConditionAction {
  Show = 0,
  Hide = 1
}
